// extracted by css-extract-rspack-plugin
export default {"item":"y0hT5"};